import { SecurityRight } from 'app/utility/enums';
import { UserService } from 'app/services/user.service';
import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
    template: `
		<ion-list class="ion-no-margin" inset="false" mode="md">
			<ion-item (click)="performAction('vehicles')">
				<ion-label>Supplier vehicles</ion-label>
			</ion-item>
		</ion-list>
		`,
    standalone: false
})
export class WholesaleSupplierPopover
{
	constructor(
		private popoverCtrl: PopoverController,
		private userService: UserService)
	{

	}

	async onDismiss()
	{
		try
		{
			await this.popoverCtrl.dismiss();
		} catch (e)
		{
			//click more than one time popover throws error, so ignore...
		}
	}

	async performAction(action: string)
	{
		await this.popoverCtrl.dismiss(action);
	}



	hasPermission(action: string): boolean
	{
		switch (action)
		{
			case "offers":
				return true;
				break;
			default:
				// console.log(action+" has no permission");
				return true;
				break;
		}
	}

}
